import React from 'react';
import CaseStudyTemplate, {
  CaseStudySection,
  GraphicPlaceholder,
  StoryParagraph,
} from './CaseStudyTemplate';

const OfficeMinutesCaseStudy = () => {
  return (
    <CaseStudyTemplate
      title="Designing OfficeMinutes for high-volume classroom support"
      intro="I redesigned a classroom office-hours queue so students can ask for help without chaos and teaching teams can triage support in real time."
      details={[
        { label: 'Role', value: 'Product Designer' },
        { label: 'Timeline', value: '2024 to 2025' },
        { label: 'Platform', value: 'Web app' },
        { label: 'Context', value: 'University pilot environments' },
      ]}
      sectionNav={[
        { id: 'overview', label: 'Overview' },
        { id: 'architecture', label: 'Architecture' },
        { id: 'features', label: 'Features' },
        { id: 'notes', label: 'Notes' },
      ]}
      backTarget="selected-work"
    >
      <CaseStudySection id="overview" title="Overview">
        <StoryParagraph>
          Traditional office hours break down at scale: long waits, duplicated questions, and no clear visibility for students or staff. The experience feels random even when everyone is working hard.
        </StoryParagraph>
        <StoryParagraph>
          OfficeMinutes reframes support as a managed queue with shared context so students can stay focused and teaching teams can prioritize fairly.
        </StoryParagraph>
      </CaseStudySection>
      <CaseStudySection id="architecture" title="Architecture">
        <StoryParagraph>
          We designed for two synchronized surfaces: a lightweight student submission flow and a triage workspace for TAs. Both surfaces share status and priority logic to keep the room coordinated.
        </StoryParagraph>
        <GraphicPlaceholder
          title="Graphic placeholder: dual-surface system"
          note="Show the student queue feed and TA control panel with mirrored state updates."
        />
      </CaseStudySection>
      <CaseStudySection id="features" title="Features">
        <StoryParagraph>
          Key patterns include private and public question modes, queue grouping, and clear progress feedback. The interaction model is intentionally minimal so users can operate under time pressure.
        </StoryParagraph>
      </CaseStudySection>
      <CaseStudySection id="notes" title="Notes">
        <StoryParagraph>
          The project sharpened my approach to service design in constrained settings: when environment noise is high, the product has to feel calm, legible, and procedural.
        </StoryParagraph>
      </CaseStudySection>
    </CaseStudyTemplate>
  );
};

export default OfficeMinutesCaseStudy; 